import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoConejo = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Conejo - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Conejo. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Conejo." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="conejo" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Conejo</h1>
              <p className="text-muted-foreground">Años: 1927, 1939, 1951, 1963, 1975, 1987, 1999, 2011, 2023</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu sensibilidad y encanto natural brillan especialmente hoy, Conejo. Las relaciones se beneficiarán de tu tacto diplomático. Los solteros atraerán personas refinadas y cultas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu habilidad para negociar y crear armonía será invaluable hoy. Situaciones que requieren tacto y diplomacia se resolverán favorablemente gracias a tu intuición social.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu naturaleza tranquila te favorece. Busca ambientes serenos y armoniosos. Actividades relajantes como paseos en la naturaleza o sesiones de spa serán especialmente beneficiosas.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será ideal para conversaciones íntimas y significativas. Tu capacidad de escucha profundizará las conexiones emocionales. Los solteros podrían conocer a alguien especial en entornos culturales.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu creatividad y buen gusto serán reconocidos. Proyectos que requieren sensibilidad estética o trato con clientes se desarrollarán exitosamente bajo tu dirección.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu bienestar emocional está en buen estado. Mantén tu entorno agradable y evita conflictos innecesarios. La música suave y actividades artísticas nutrirán tu espíritu.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana romántica y armoniosa te espera. Tu gracia natural creará momentos mágicos con tu pareja. Los solteros se encontrarán en situaciones sociales que favorecen nuevos encuentros.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana destacarás en situaciones que requieren diplomacia y refinamiento. Tu capacidad para crear consenso facilitará el progreso de proyectos importantes.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Prioriza la paz interior esta semana. Evita ambientes estresantes y busca actividades que nutran tu necesidad de belleza y tranquilidad. El equilibrio será tu mejor medicina.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoConejo;
